import Vue from 'vue'
import VueEvents from 'vue-events'
import Vuelidate from 'vuelidate'
import VueTour from 'vue-tour'
//import VueMatomo from 'vue-matomo'
import VueCookies from 'vue-cookies'
import App from './layouts/App.vue'
import API from '@/services/api'
import vuetify from './plugins/vuetify'
import router from '@/router'
import store from '@/store'
import i18n from '@/locale'
import '@/filters'
import get from 'lodash/get'

import { Notifier } from '@airbrake/browser'

import '@/styles/main.scss'

import './registerServiceWorker'

Vue.config.productionTip = false

//- Airbrake error logging
if (process.env.VUE_APP_AIRBRAKE_PROJECT && process.env.VUE_APP_AIRBRAKE_KEY) {
  const airbrake = new Notifier({
    projectId: Number(process.env.VUE_APP_AIRBRAKE_PROJECT), // <— viktigt: nummer
    projectKey: process.env.VUE_APP_AIRBRAKE_KEY,
    environment: process.env.NODE_ENV, // 'development' | 'production' | 'test'
    instrumentation: {
      onerror: false,          // <— undvik duplikat: vi använder Vue errorHandler
      unhandledrejection: true // <— låt Airbrake fånga promises utanför Vue
      // console/fetch/xhr/history: default (ändra om du vill tysta dem)
    }
  })

  Vue.config.errorHandler = function (err, vm, info) {
    airbrake.notify({
      error: err,
      context: { component: 'minasidor' },
      params: { info }
    })
  }

  // (valfritt) gör tillgängligt globalt om du vill kunna logga manuellt:
  // Vue.prototype.$airbrake = airbrake
}

//- Define a scroll to top function to use with vue-router if opeing same route (with different content) twice
Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0)

// Add commonly used fuctions to global context
Vue.set(Vue.prototype, 'loGet', get);

//- Validations for forms and such
Vue.use(Vuelidate)
Vue.use(VueEvents)
Vue.use(VueCookies)
Vue.use(require('vue-shortkey'), { prevent: ['textarea'] })

require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

// REMOVE COMMENT WHEN MATOMO IS NEEDED
/* Vue.use(VueMatomo, {
  // Configure your matomo server and site by providing
  host: 'http://tullbox.local/',
  siteId: 2,
  trackerFileName: 'matomo',
  router,
  enableLinkTracking: true,
  requireConsent: false,
  trackInitialView: true,
  disableCookies: false,
  enableHeartBeatTimer: false,
  heartBeatTimerInterval: 15,
  debug: false,
  cookieDomain: undefined,
  domains: undefined,
  preInitActions: []
}) */

// Initialize what needs to be initialized and start up application
Promise.all([API.init(), store.dispatch('init')]).then(
  new Vue({
    vuetify,
    router,
    store,
    i18n,
    created() {
      API.dialog = this.$dialog
      API.events = this.$events
      API.store = this.$store
    },
    render: h => h(App)
  }).$mount('#app')
)
